import { addEffect, addState, flowMax, SimpleUnchangedProps } from 'ad-hok'
import { getContextHelpers, toObjectKeys } from 'ad-hok-utils'

interface IsTouchActiveContext {
  isTouchActive: boolean
}

const [addIsTouchActiveContextProviderBase, addIsTouchActiveContext] =
  getContextHelpers<IsTouchActiveContext>(toObjectKeys(['isTouchActive']))

export { addIsTouchActiveContext }

export const addIsTouchActiveContextProvider: SimpleUnchangedProps = flowMax(
  addState('isTouchActive', 'setIsTouchActive', false),
  addEffect(
    ({ setIsTouchActive }) =>
      () => {
        const touchStartListener = () => {
          setIsTouchActive(true)
        }
        const touchEndListener = () => {
          setIsTouchActive(false)
        }
        window.addEventListener('touchstart', touchStartListener)
        window.addEventListener('touchend', touchEndListener)
        return () => {
          window.removeEventListener('touchstart', touchStartListener)
          window.removeEventListener('touchend', touchEndListener)
        }
      },
    []
  ),
  addIsTouchActiveContextProviderBase
)
